(function () {
  'use strict';
  angular.module('MktzapApp.Factories')
    .factory('EventService', eventService);

  eventService.$inject = ['$resource'];

  function eventService ($resource) {
    return $resource(apiUrl + '/event', {}, {
      getByLabelWithPagination: { method: 'GET', isArray: false },
      store: { method: 'POST', params: {}, isArray: false },
      update: { method: 'PATCH', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      getByBelongsTo: { url: apiUrl + '/event/get-by-belongs-to', method: 'GET', isArray: true },
      fireEvent: { url: apiUrl + '/event/fire-event', method: 'POST', params: {}, isArray: false },
    });
  }
})();
